import { render } from "./AppSubtraction.vue?vue&type=template&id=439b7c28"
import script from "./AppSubtraction.vue?vue&type=script&lang=js"
export * from "./AppSubtraction.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__